export function isFilterMetadata(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "created" in candidate &&
        "origin" in candidate);
}
